import { faUser } from '@fortawesome/free-regular-svg-icons';
import { errandButtonUtils } from '../../errandButtonUtils';
import { hideForReporterRule, hideWhenReadOnlyRule } from '../commonRules';
import { DataAccessAdministrationModal } from './DataAccessAdministrationModal';
export const DataAccessAdministrationButton = {
    key: 'dataAccessAdministrationButton',
    text: 'Hantera datarättigheter',
    prio: 3,
    section: 'start',
    icon: faUser,
    buttonStyle: 'primary',
    ModalComponent: DataAccessAdministrationModal,
    onClick: async (row, inca, showModal, ctx, api)=>{
        const { isSuccess, result: { res, transitionShortname } } = await showModal();
        if (!isSuccess) {
            return;
        }
        const transitionResultModel = await errandButtonUtils.performStateTransition(transitionShortname, ctx, api, res);
        if (!transitionResultModel) {
            return;
        }
        inca.form.reload();
    },
    defaultRules: [
        hideWhenReadOnlyRule,
        hideForReporterRule
    ]
};
